"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
require("./ProfileMenu.css");
var _Translations = require("../Translations");
var _config = require("../config");
var _helpers = require("../helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  return {
    userInfo: {
      borderBottom: 'solid 1px #ddd'
    }
  };
};
var ProfileMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(ProfileMenu, _React$Component);
  var _super = _createSuper(ProfileMenu);
  function ProfileMenu() {
    var _this;
    _classCallCheck(this, ProfileMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      anchorEl: null
    });
    _defineProperty(_assertThisInitialized(_this), "handleMenu", function (event) {
      _this.setState({
        anchorEl: event.currentTarget
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      _this.setState({
        anchorEl: null
      });
    });
    _defineProperty(_assertThisInitialized(_this), "logout", function () {
      _this.props.dispatch({
        type: 'LOGOUT_USER',
        history: _this.props.history
      });
      _this.setState({
        anchorEl: null
      });
    });
    return _this;
  }
  _createClass(ProfileMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        extraProfilMenuItems = _this$props.extraProfilMenuItems,
        user = _this$props.user;
      var anchorEl = this.state.anchorEl;
      var open = Boolean(anchorEl);
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
        "aria-owns": open ? 'menu-appbar' : undefined,
        "aria-haspopup": "true",
        onClick: this.handleMenu
      }, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
        src: user && user.avatar && user.avatar.original ? (0, _helpers.joinPaths)(_config.BASE_URL, user.avatar.original) : null
      }, user && user.name ? _config.NAME_ORDER_IN_CHAT === "" || _config.NAME_ORDER_IN_CHAT === "N" ? user.name[0].toUpperCase() : user.first_name[0].toUpperCase() : '?')), /*#__PURE__*/_react.default.createElement(_core.Popover, {
        id: "menu-appbar",
        anchorEl: anchorEl,
        open: open,
        onClose: this.handleClose,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        classes: {
          paper: "w-290"
        }
      }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "p-4 mt-0 bg-gray-300"
      }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true
      }, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
        src: user && user.avatar && user.avatar.original ? (0, _helpers.joinPaths)(_config.BASE_URL, user.avatar.original) : null
      }, user && user.name ? _config.NAME_ORDER_IN_CHAT === "" || _config.NAME_ORDER_IN_CHAT === "N" ? user.name[0].toUpperCase() : user.first_name[0].toUpperCase() : '?')), /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true
      }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
        variant: "subtitle2",
        gutterBottom: true
      }, user && _config.NAME_ORDER_IN_CHAT === "" ? user.name : _config.NAME_ORDER_IN_CHAT === "P" ? user.first_name + " " + user.last_name : user.last_name + " " + user.first_name)))), /*#__PURE__*/_react.default.createElement(_core.Divider, null), /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
        component: _reactRouterDom.Link,
        to: "/profile",
        onClick: this.handleClose
      }, /*#__PURE__*/_react.default.createElement(_core.ListItemIcon, null, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "account_circle")), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
        className: "pl-0",
        primary: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
          id: "Mon profil"
        })
      })), extraProfilMenuItems && extraProfilMenuItems.map(function (item) {
        return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
          component: _reactRouterDom.Link,
          to: item.url,
          onClick: _this2.handleClose
        }, /*#__PURE__*/_react.default.createElement(_core.ListItemIcon, null, /*#__PURE__*/_react.default.createElement(_core.Icon, null, item.icon)), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
          className: "pl-0",
          primary: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
            id: item.name
          })
        }));
      }), /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
        onClick: this.logout
      }, /*#__PURE__*/_react.default.createElement(_core.ListItemIcon, null, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "exit_to_app")), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
        className: "pl-0",
        primary: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
          id: "Logout"
        })
      })))));
    }
  }]);
  return ProfileMenu;
}(_react.default.Component);
var _default = (0, _styles.withStyles)(styles)((0, _reactRedux.connect)()(ProfileMenu));
exports.default = _default;